//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:{
        questionInfo:{
            type:Object,
            default: function(){
                return {
                    content:'',
                    vet:{},
                    pet:{ type:'猫' },
                    title:'',
                    queryCategoryList:[]
                }
            }
        }
    },
    data() {
        return {
            
        }
    },
    computed: {
        tagList(){
            return this.questionInfo.queryCategoryList.filter((v)=>{
                // return v.id != 50
                if(v.id!=50){
                    if(v.id===3){
                        v.category ='驱虫'
                    }
                    if(v.id===4){
                        v.category ='软便'
                    }
                    if(v.id===2){
                        v.category ='免疫'
                    }
                    if(v.id===21){
                        v.category ='乱叫'
                    }
                    return v
                }
            })
        }
    },
    methods: {
        click() {
		    console.log(2222)
            this.$emit('click',this.questionInfo.id)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Questioncard.vue